import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var OrderListRes;
export const OrderListTodo = createAsyncThunk('OrderList', async (data) => {
    // console.log("Page limit", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'main_List',
            data: {
                "vtype": localStorage.getItem('cTax_type'),
                "vcustomer_code": localStorage.getItem('vcust_plant_code'),
                "vpo_code": data?.search,
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "vfin_year": localStorage.getItem('vfin_year'),
                "vfrom_date": data?.fromDate,
                "vto_date": data?.toDate,
                "pageing": data?.pageSize,
                "ilimit": data?.pageLimit
            },
            headers: { "Content-Type": "application/json" },

        })
        return OrderListRes = res.data

    } catch (error) {
        return OrderListRes = error.response.data
    }
});

const OrderListSlice = createSlice({
    name: 'OrderList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(OrderListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(OrderListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default OrderListSlice.reducer; 